import * as React from 'react';
import Modal from '@mui/material/Modal';
import axios from 'axios';
import { useForm, SubmitHandler } from 'react-hook-form';
import { useState } from 'react';
import baseUrlApi from '../../lib/baseUrlApi';
import {useCookies} from "react-cookie";
import {useNavigate} from "react-router-dom";
import {ApiRequest} from "../../Consts/ApiRequest";
import { modalProps } from '../../Consts/constants';

type AdminInputs = {
    "siteId": string,
    "siteRecno": number,
    "prcKind": number,
    "sitePass": {
        "admin": string,
        "user": string
    }

};
interface AdminDeleteProps {
    site_id: string;
    admin_password: string;
    user_password: string;
    siteRecno: number,
    closeModal: Function;
    setState: Function;
};
export default function AdminModalDelete(props: AdminDeleteProps) {
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => {
        setOpen(true);
        resetData();
    }
    const handleClose = () => {
        setOpen(false);
        resetData();
    }

    const site_id = props.site_id;
    const admin_password = props.admin_password;
    const user_password = props.user_password;
    const siteRecno = props.siteRecno;
    const closeModal = props.closeModal;
    const [error, setError] = useState<[]>([]);
    const [cookies, setCookie, removeCookie] = useCookies(['authority', 'access_token', "siteId", "siteRecno"]);
    const navigate = useNavigate();
    const { register, handleSubmit, formState: { errors } } = useForm<AdminInputs>();

    const resetData = async() => {
        setError([]);
    };


    function errorCallback(error:any){
        if (error.response && error.response.status === 401) {
            console.error("Error token error:", error);
            removeCookie('access_token', {path: '/'});
            removeCookie('authority', {path: '/'});
            removeCookie('siteId', {path: '/'});
            removeCookie('siteRecno', {path: '/'});
            navigate("logout");
        }
        console.error("Error fetching dataSite:", error);
    }

    const onSubmit: SubmitHandler<AdminInputs> = async (data) => {
        try {
            const token = cookies.access_token || "";
            let params = {
                "siteId": site_id,
                "siteRecno": siteRecno,
                "prcKind": 2,
                "sitePass": {
                    "admin": admin_password,
                    "user": user_password
                }
            };
            await ApiRequest.registSiteManage(params, token, (response: any) => {
                setError(response.data.messsages);
                if (response.data.result === 0) {
                    handleClose();
                    closeModal();
                }
                props.setState(" ");
            }, (error: any) => {
                errorCallback(error);
            });
        } catch (error) {
            console.error("Error fetching data:", error);
            handleClose();
        }
    }
    return (
        <div>
            <button onClick={handleOpen} className="btn btn-red-line">
                <i className="icon-delete-r">
                </i>削除</button>

                <Modal {...modalProps} open={open}>
                <div className="modal-wrapper" style={{ display: "flex" }} id="modal-message">
                    <div className="modal">
                        <div className="modal-header">
                            <div className="modal-title">
                                削除確認
                            </div>
                            <a onClick={handleClose} className="modal-close"></a>
                        </div>
                        <div className="modal-body">
                            <div className="edit-box">
                                {
                                    error && error.length > 0 ?
                                        <ul className="error-box">
                                            {error.map((err, index) => <li key={index}>{err}</li>)}
                                        </ul>
                                        : null
                                }
                                本当に削除してもよろしいですか？
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="model-action-sub">
                            </div>
                            <div className="model-action-main">
                                <button onClick={handleClose} className="btn btn-blue-line">
                                    キャンセル
                                </button>
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <button className="btn btn-red-line">
                                        <i className="icon-delete-r"></i>確定
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
};
